// extracted by mini-css-extract-plugin
module.exports = {"questionBorder":"QuestionsBucket_questionBorder__1_nkB","title":"QuestionsBucket_title__Csb-I"};